import { useEffect, useState } from 'react';

function useNavButtons(listRef, width, children: number): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const listElement = listRef.current;

    if (listElement && listElement.scrollWidth > listElement.offsetWidth) {
      setShow(() => true);
    } else {
      setShow(() => false);
    }
  }, [listRef, width, children]);

  return show;
}

export default useNavButtons;
